<template>
    <div class="katalog">
        <div class="katalog__one">
            <h2 class="sec__title katalog__one-title">TAKLIF QILAMIZ</h2>
            <div class="katalog__one-info">
                <div v-for="(one,i) in kOne" :key="i" class="katalog__one-info__card">
                    <img :src="one.img" alt="">
                    <h2>{{one.title}}</h2>
                </div>
            </div>
        </div>
        
        <div class="katalog__two">
            <h2 class="sec__title katalog__two-title">КАТАЛОГ</h2>
            <div class="katalog__two-info">
                <swiper
                    :slidesPerView="4"
                    :spaceBetween="0"
                    :slidesPerGroup="1"
                    :loop="false"
                    :loopFillGroupWithBlank="true"
                    :pagination="{
                        clickable: true,    
                        dynamicBullets: true,
                    }"
                    :breakpoints="{
                        '0':{
                            slidesPerView: 1,
                            spaceBetween: 5
                        },
                        '450':{
                            slidesPerView: 2,
                            spaceBetween: 5
                        },
                        '800':{
                            slidesPerView: 3,
                            spaceBetween: 5
                        },
                        '1100':{
                            slidesPerView: 4,
                            spaceBetween: 5
                        },
                    }"
                    :navigation="true"
                    :modules="modules"
                    class="mySwiper"
                >
                    <swiper-slide v-for="(two,i) in kTwo" :key="i">
                        <div class="katalog__two-info__card">
                            <img :src="two.img" alt="">
                            <h2>{{two.text}}</h2>
                            <div class="katalog__two-info__card-hover">
                                <p>Lorem, ipsum dolor.</p>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>

import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./style.css";

// import required modules
import { Pagination, Navigation } from "swiper";
export default {
    props:{
        kOne:Array,
        kTwo:Array,
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            
        }
    },
    setup() {
        return {
        modules: [Pagination, Navigation],
    };
  },
}
</script>
<style lang="scss">
</style>